(function () {
  var blockedPatterns = [
    'na.shgcdn3.com/pixel-collector.js'
  ];

  var storageKey = '__blockedShogunScripts';

  function hasAnalyticsConsent() {
    return Boolean(
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
      Shopify.customerPrivacy.analyticsProcessingAllowed()
    );
  }

  function matchesBlockedPattern(src) {
    if (!src) return false;

    return blockedPatterns.some(function (pattern) {
      return src.indexOf(pattern) !== -1;
    });
  }

  function isBlockedScript(node) {
    return Boolean(
      node &&
      node.nodeType === 1 &&
      node.tagName === 'SCRIPT' &&
      node.src &&
      matchesBlockedPattern(node.src) &&
      !hasAnalyticsConsent()
    );
  }

  function getBlockedScripts() {
    window[storageKey] = window[storageKey] || [];
    return window[storageKey];
  }

  function rememberBlockedScript(node) {
    var blockedScripts = getBlockedScripts();

    var alreadyStored = blockedScripts.some(function (item) {
      return item.src === node.src;
    });

    if (alreadyStored) return;

    blockedScripts.push({
      src: node.src,
      async: node.async,
      defer: node.defer,
      type: node.type || '',
      integrity: node.integrity || '',
      crossOrigin: node.crossOrigin || '',
      referrerPolicy: node.referrerPolicy || '',
      nonce: node.nonce || ''
    });
  }

  function createScript(item) {
    var script = document.createElement('script');

    script.src = item.src;
    script.async = item.async !== false;
    script.defer = item.defer === true;

    if (item.type) {
      script.type = item.type;
    }

    if (item.integrity) {
      script.integrity = item.integrity;
    }

    if (item.crossOrigin) {
      script.crossOrigin = item.crossOrigin;
    }

    if (item.referrerPolicy) {
      script.referrerPolicy = item.referrerPolicy;
    }

    if (item.nonce) {
      script.nonce = item.nonce;
    }

    script.setAttribute('data-consent-loaded', 'true');

    return script;
  }

  function scriptAlreadyLoaded(src) {
    var scripts = document.getElementsByTagName('script');

    for (var i = 0; i < scripts.length; i++) {
      if (
        scripts[i].src === src &&
        scripts[i].getAttribute('data-consent-loaded') === 'true'
      ) {
        return true;
      }
    }

    return false;
  }

  function loadBlockedScriptsAfterConsent() {
    if (!hasAnalyticsConsent()) return;

    var blockedScripts = getBlockedScripts();

    if (!blockedScripts.length) return;

    var scriptsToLoad = blockedScripts.slice();

    window[storageKey] = [];

    scriptsToLoad.forEach(function (item) {
      if (scriptAlreadyLoaded(item.src)) return;

      var script = createScript(item);

      originalAppendChild.call(document.head || document.documentElement, script);

      console.info(
        'Loaded Shogun pixel collector after analytics consent:',
        item.src
      );
    });
  }

  function blockScript(node) {
    console.warn(
      'Blocked Shogun pixel collector before analytics consent:',
      node.src
    );

    rememberBlockedScript(node);

    return node;
  }

  var originalAppendChild = Element.prototype.appendChild;
  var originalInsertBefore = Element.prototype.insertBefore;
  var originalAppend = Element.prototype.append;
  var originalPrepend = Element.prototype.prepend;
  var originalReplaceChild = Element.prototype.replaceChild;

  Element.prototype.appendChild = function (node) {
    if (isBlockedScript(node)) {
      return blockScript(node);
    }

    return originalAppendChild.call(this, node);
  };

  Element.prototype.insertBefore = function (node, referenceNode) {
    if (isBlockedScript(node)) {
      return blockScript(node);
    }

    return originalInsertBefore.call(this, node, referenceNode);
  };

  Element.prototype.replaceChild = function (newNode, oldNode) {
    if (isBlockedScript(newNode)) {
      blockScript(newNode);
      return oldNode;
    }

    return originalReplaceChild.call(this, newNode, oldNode);
  };

  if (typeof originalAppend === 'function') {
    Element.prototype.append = function () {
      var nodes = Array.prototype.slice.call(arguments);
      var allowedNodes = [];

      nodes.forEach(function (node) {
        if (isBlockedScript(node)) {
          blockScript(node);
        } else {
          allowedNodes.push(node);
        }
      });

      if (allowedNodes.length) {
        return originalAppend.apply(this, allowedNodes);
      }
    };
  }

  if (typeof originalPrepend === 'function') {
    Element.prototype.prepend = function () {
      var nodes = Array.prototype.slice.call(arguments);
      var allowedNodes = [];

      nodes.forEach(function (node) {
        if (isBlockedScript(node)) {
          blockScript(node);
        } else {
          allowedNodes.push(node);
        }
      });

      if (allowedNodes.length) {
        return originalPrepend.apply(this, allowedNodes);
      }
    };
  }

  document.addEventListener(
    'visitorConsentCollected',
    loadBlockedScriptsAfterConsent
  );

  document.addEventListener(
    'shopify:customer_privacy:loaded',
    loadBlockedScriptsAfterConsent
  );

  window.addEventListener('load', loadBlockedScriptsAfterConsent);

  setTimeout(loadBlockedScriptsAfterConsent, 500);
  setTimeout(loadBlockedScriptsAfterConsent, 1500);
})();